import "@/App.css";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Problem } from "@/components/site/Problem";
import { Divisions } from "@/components/site/Divisions";
import { Services } from "@/components/site/Services";
import { ExecutiveSupport } from "@/components/site/ExecutiveSupport";
import { FamilySupport } from "@/components/site/FamilySupport";
import { Experience } from "@/components/site/Experience";
import { Testimonials } from "@/components/site/Testimonials";
import { Booking } from "@/components/site/Booking";
import { ContactWhatsApp } from "@/components/site/ContactWhatsApp";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Problem />
        <Divisions />
        <Services />
        <ExecutiveSupport />
        <FamilySupport />
        <Experience />
        <Testimonials />
        <Booking />
        <ContactWhatsApp />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
